export default class EventableObject {
  __touchEventListeners(event_names) {
    if (!this.__event_listeners)
      this.__event_listeners = {};
    event_names.split(' ').forEach(event_name => {
      if (!this.__event_listeners[event_name])
        this.__event_listeners[event_name] = [];
    });
  }

  addEventListener(event_names, listener) {
    this.__touchEventListeners(event_names);
    event_names.split(' ').forEach(event_name => {
      this.__event_listeners[event_name].push(listener);
    });
  }

  removeEventListener(event_names, listener) {
    this.__touchEventListeners(event_names);
    event_names.split(' ').forEach(event_name => {
      this.__event_listeners[event_name] = this.__event_listeners.filter(x => x != listener);
    });
  }

  clearEventListeners(event_names) {
    if (event_names === undefined) {
      this.__event_listeners = {};
    } else {
      this.__touchEventListeners(event_names);
      event_names.split(' ').forEach(event_name => {
        this.__event_listeners[event_name] = [];
      });
    }
  }

  triggerEvent(event_names, data, context) {
    if (context === undefined)
      context = this;
    this.__touchEventListeners(event_names);
    event_names.split(' ').forEach(event_name => {
      this.__event_listeners[event_name].every(listener => {
        if (listener.call(context, data) === false) {
          return false;
        }
      });
    });
  }
}
